






















































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as moment from "moment";
import _ from "lodash";
import ListState from "../../../store/modules/list-state";
import LineChart from "@/components/charts/lineChart";
import PieChart from "@/components/charts/pieChart";
import BarChart from "@/components/charts/barChart";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import DashboardInfo from "@/store/entities/dashboard-backlog-output";
import DashboardInboundBacklog from "@/store/entities/dashboard-inbound-backlog";
import DashboardEmpStatBacklog from "@/store/entities/dashboard-empstat-backlog";
import DashboardEmpWorOrderStatBacklog from "@/store/entities/dashboard-empstat-workorder-backlog";
import DashboardWorkOrderStatBacklog from "@/store/entities/dashboard-workorder-stat-backlog";
import DashboardSoProcessBacklog from "@/store/entities/dashboard-soprocess-backlog";
import DashboardSoAgingBacklog from "@/store/entities/dashboard-soaging-backlog";
import SOProcessColumns from "@/views/operation/reports/soProcess-columns";
import SOAgingColumns from "@/views/operation/reports/soAging-columns";
class PageDashboardRequest extends PageRequest {
  warehouseCode: string;
  fromDate?: Date;
  toDate?: Date;
}
class InOutboundData {
  inboundNew: number = 0;
  needReceive: number = 0;
  needPutaway: number = 0;
  putawayed: number = 0;
  preorder: number = 0;
  outboundNew: number = 0;
  needToPick: number = 0;
  needToPack: number = 0;
  needToShip: number = 0;
  shipped: number = 0;
}
@Component({
  components: {
    "line-chart": LineChart,
    "pie-chart": PieChart,
    "bar-chart": BarChart,
  },
})
export default class DashboardReport extends AbpBase {
  isLoading = false;
  //filters
  pagerequest: PageDashboardRequest = new PageDashboardRequest();
  warehouses = [];
  soProcessDataPage: ListState<DashboardSoProcessBacklog> = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<DashboardSoProcessBacklog>(),
    loading: false,
  };
  soAgingDataPage: ListState<DashboardSoAgingBacklog> = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<DashboardSoAgingBacklog>(),
    loading: false,
  };
  dashboardInfo: DashboardInfo = new DashboardInfo();
  inboundBacklog: Array<DashboardInboundBacklog> =
    new Array<DashboardInboundBacklog>();
  outboundBacklog: Array<DashboardInboundBacklog> =
    new Array<DashboardInboundBacklog>();
  empStatBacklog: Array<DashboardEmpStatBacklog> =
    new Array<DashboardEmpStatBacklog>();
  empWorkOrderStatBacklog: Array<DashboardEmpWorOrderStatBacklog> =
    new Array<DashboardEmpWorOrderStatBacklog>();

  woStatBacklog: Array<DashboardWorkOrderStatBacklog> =
    new Array<DashboardWorkOrderStatBacklog>();
  soProcessBacklog: Array<DashboardSoProcessBacklog> =
    new Array<DashboardSoProcessBacklog>();
  soAgingBacklog: Array<DashboardSoAgingBacklog> =
    new Array<DashboardSoAgingBacklog>();
  lineChartInboundData: any = null;
  lineChartOutboundData: any = null;
  pieChartEmpStatData: any = null;
  barChartWorkOrderStatData: any = null;
  inboundBacklogOptions: any = this.chartOptions([Util.L("InboundBacklog")]);
  outboundBacklogOptions: any = this.chartOptions([Util.L("OutboundBacklog")]);

  inoutboundData: InOutboundData = new InOutboundData();

  barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: true },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: { display: false },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            suggestedMin: 0,
            callback: function (value) {
              return Util.toViewNumberString(value);
            },
          },
        },
      ],
    },
    animation: {
      duration: 10,
    },
    tooltip: {
      mode: "label",
      callbacks: {
        label: function (tooltipItem, data) {
          return (
            data.datasets[tooltipItem.datasetIndex].label +
            ": " +
            Util.toViewNumberString(tooltipItem.yLabel)
          );
        },
      },
    },
    title: {
      display: true,
      text: Util.L("WorkOrderStatsBacklog"),
    },
  };
  pieChartEmpStatOptions: any = {
    cutoutPercentage: 0,
    responsive: true,
    maintainAspectRatio: false,
    pieceLabel: {
      render: "value",
      precision: 1,
    },
    showDatapoints: true,
    showAllTooltips: true,
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var filterValue = data.statuses[tooltipItem.index];
          var empWorkOrders = _.filter(data.empWorkOrderStats, function (o) {
            return o.status === filterValue;
          });
          if (Util.isNull(empWorkOrders) || empWorkOrders.length <= 0)
            return (
              " " +
              Util.toViewNumberString(
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              ) +
              " - " +
              data.labels[tooltipItem.index]
            );
          else {
            var tooltipText = [];
            _.forEach(empWorkOrders, function (item) {
              tooltipText.push(
                " " +
                  Util.toViewNumberString(item.numOfEmp) +
                  " - " +
                  item.workOrderTypeName
              );
            });
            return tooltipText;
          }
        },
        labelTextColor: function (tooltipItem, chart) {
          return "#FFF";
        },
      },
    },
    title: {
      display: true,
      text: Util.L("EmpStatsBacklog"),
    },
  };
  chartOptions(titleText: Array<string>) {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              suggestedMin: 0,
            },
          },
        ],
      },
      tooltip: {
        mode: "label",
        callbacks: {
          label: function (tooltipItem, data) {
            return (
              data.datasets[tooltipItem.datasetIndex].label +
              ": " +
              Util.toViewNumberString(tooltipItem.yLabel)
            );
          },
        },
      },
      title: {
        display: true,
        text: titleText,
      },
    };
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }

  async getDashboardInfo() {
    this.isLoading = true;
    try {
      this.preGetPage();
      this.$store
        .dispatch({
          type: "report/getDashboardBacklog",
          data: this.pagerequest,
        })
        .then((result) => {
          if (result) {
            this.dashboardInfo = result;
            // this.inboundBacklog = result.inbound;
            // this.outboundBacklog = result.outbound;
            this.empStatBacklog = result.empStats;
            this.woStatBacklog = result.workOrderStats;
            this.soAgingBacklog = result.soAgings;
            this.soProcessBacklog = result.soProcesses;
            this.empWorkOrderStatBacklog = result.empWorkOrderStats;
            this.soAgingPageChangeItems();
            this.soProcessPageChangeItems();
            // this.lineChartInboundData = this.buildChartData(
            //   this.inboundBacklog,
            //   AppConsts.dashboardBacklogInfo.inboundBackgroundColor
            // );
            // this.lineChartOutboundData = this.buildChartData(
            //   this.outboundBacklog,
            //   AppConsts.dashboardBacklogInfo.outboundBackgroundColor
            // );
            this.pieChartEmpStatData = this.buildPieChartData(
              this.empStatBacklog,
              AppConsts.dashboardBacklogInfo.empStatBackgroundColor
            );
            this.barChartWorkOrderStatData = this.buildBarChartData(
              this.woStatBacklog,
              AppConsts.dashboardBacklogInfo.woStatBackgroundColor
            );
            if (result.inOutboundData.length > 0)
              this.inoutboundData = result.inOutboundData[0];
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    } catch {
      this.isLoading = false;
    }
  }
  preGetPage() {
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    var toMoment = moment();
    var fromMoment = moment().subtract(
      AppConsts.dashboardBacklogInfo.rangeDate,
      "d"
    );
    var toDate = new Date(toMoment.format(AppConsts.reportDateFormat));
    var fromDate = new Date(fromMoment.format(AppConsts.reportDateFormat));
    this.pagerequest.fromDate = fromDate;
    this.pagerequest.toDate = toDate;
  }
  buildChartData(data: any, chartColors: any) {
    if (!Util.isNull(data)) {
      var lineChartProp = AppConsts.dashboardBacklogInfo.lineChartProp;
      var datasets = [];
      var labels = data.map((item) =>
        Util.toBacklogDateString(item.backlogDate)
      );
      labels = labels.filter(Util.onlyUnique);
      var statuses = data.map((item) => item.status);
      statuses = statuses.filter(Util.onlyUnique);
      _.forEach(statuses, function (element) {
        var items = data.filter((item) => item.status == element);

        if (items != null || items.length > 0) {
          var dataObj = {
            label: items[0].statusName,
            backgroundColor: chartColors[element],
            borderColor: chartColors[element],
            data: items.map((item) => item.qty),
            fill: lineChartProp.fill,
            borderWidth: lineChartProp.borderWidth,
          };
          datasets.push(dataObj);
        }
      });
      return {
        labels: labels,
        datasets: datasets,
      };
    }
    return null;
  }
  buildBarChartData(data: any, chartColors: any) {
    if (!Util.isNull(data)) {
      var lineChartProp = AppConsts.dashboardBacklogInfo.lineChartProp;
      var datasets = [];
      var labels = data.map((item) => item.workOrderTypeName);
      labels = labels.filter(Util.onlyUnique);
      var statuses = data.map((item) => item.status);
      statuses = statuses.filter(Util.onlyUnique);
      _.forEach(statuses, function (element) {
        var items = data.filter((item) => item.status == element);

        if (items != null || items.length > 0) {
          var dataObj = {
            label: items[0].statusName,
            backgroundColor: chartColors[element],
            borderColor: chartColors[element],
            data: items.map((item) => item.numOfTask),
          };
          datasets.push(dataObj);
        }
      });
      return {
        labels: labels,
        datasets: datasets,
      };
    }
    return null;
  }
  buildPieChartData(data: any, chartColors: any) {
    if (!Util.isNull(data)) {
      var datasets = [];
      var labels = data.map((item) => item.statusName);
      labels = labels.filter(Util.onlyUnique);
      var backgroundColors = [];
      _.forEach(data, function (element) {
        backgroundColors.push(chartColors[element.status]);
      });
      var numOfEmps = data.map((item) => item.numOfEmp);
      var statuses = data.map((item) => item.status);
      var dataObj = {
        backgroundColor: backgroundColors,
        data: numOfEmps,
        borderWidth: 0,
      };
      datasets.push(dataObj);
      return {
        labels: labels,
        datasets: datasets,
        statuses: statuses,
        empWorkOrderStats: this.empWorkOrderStatBacklog,
      };
    }
    return null;
  }
  //------ so process
  get soProcessList() {
    return this.soProcessDataPage.list;
  }
  get soProcessPageSize() {
    return this.soProcessDataPage.pageSize;
  }
  get soProcessTotalCount() {
    return this.soProcessDataPage.totalCount;
  }
  get soProcessCurrentPage() {
    return this.soProcessDataPage.currentPage;
  }
  soProcessPageChange(page: number) {
    this.soProcessDataPage.currentPage = page;
    this.soProcessPageChangeItems();
  }
  soProcessPagesizeChange(pagesize: number) {
    this.soProcessDataPage.pageSize = pagesize;
    this.soProcessPageChangeItems();
  }
  soProcessPageChangeItems() {
    this.soProcessDataPage.loading = true;
    this.soProcessDataPage.list = Util.pagingItems(
      this.soProcessBacklog,
      this.soProcessDataPage.pageSize,
      this.soProcessDataPage.currentPage
    );
    this.soProcessDataPage.loading = false;
  }
  get soProcessLoading() {
    return this.soProcessDataPage.loading;
  }
  //------ so aging
  get soAgingList() {
    return this.soAgingDataPage.list;
  }
  get soAgingPageSize() {
    return this.soAgingDataPage.pageSize;
  }
  get soAgingTotalCount() {
    return this.soAgingDataPage.totalCount;
  }
  get soAgingCurrentPage() {
    return this.soAgingDataPage.currentPage;
  }
  soAgingPageChange(page: number) {
    this.soAgingDataPage.currentPage = page;
    this.soAgingPageChangeItems();
  }
  soAgingPagesizeChange(pagesize: number) {
    this.soAgingDataPage.pageSize = pagesize;
    this.soAgingPageChangeItems();
  }
  soAgingPageChangeItems() {
    this.soAgingDataPage.loading = true;
    this.soAgingDataPage.totalCount = this.soAgingBacklog.length;
    this.soAgingDataPage.list = Util.pagingItems(
      this.soAgingBacklog,
      this.soAgingDataPage.pageSize,
      this.soAgingDataPage.currentPage
    );
    this.soAgingDataPage.loading = false;
  }
  get soAgingLoading() {
    return this.soAgingDataPage.loading;
  }
  soProcessColumns = SOProcessColumns;
  soAgingColumns = SOAgingColumns;

  async created() {
    await this.getWarehouses();
    await this.getDashboardInfo();
  }
}
